import BigQuote from "./BigQuote";

export default BigQuote;
